module.exports = __webpack_public_path__ + "static/media/masa.5850fffb.svg";